import React, {useContext, useState, useEffect} from 'react'
import AuthContext from '../../context/AuthContext'
import { Link, Redirect, useHistory} from "react-router-dom";
const { REACT_APP_DEV_API_URL, REACT_APP_PROD_API_URL, NODE_ENV } = process.env;

const API_URL = 
  NODE_ENV === 'production' ? process.env.REACT_APP_PROD_API_URL : process.env.REACT_APP_DEV_API_URL;

const PasswordReset = () => {
    let {passwordReset, user, errorMessage, successMessage} = useContext(AuthContext)
    let [emailBlank, setEmailBlank] = useState(false)

    let [clientIP, setClientIP] = useState("")

    let blankError = (val, name )=> {
      if (val == "" && name =="email") {
        setEmailBlank(true)
      }else if(name == "email"){
        setEmailBlank(false)
      }
    }

    let getClientIP = async () => {
      let response = await fetch(`${API_URL}/tools/ip/`)
      let data = await response.json()
      setClientIP(data)
    }

    useEffect(() => {
      document.title = "Forgot Password | WillowBMS"
      getClientIP()
    }, [])
    
    return (
        <div className="antialiased border-top-wide border-primary d-flex flex-column">
            {user && <Redirect to="/" />}
    <div className="page page-center">
      <div className="container-tight py-4">
        <div className="text-center mb-4">
          <Link to=""><img src="./static/logo.svg" height="36" alt=""/></Link>
        </div>
        <form onSubmit={passwordReset} className="card card-md" autoComplete="off">
          <div className="card-body">
            <h2 className="card-title text-center mb-4">Forgot Password</h2>
            <p className="text-muted mb-4">Enter your email address to receive instructions on how to reset your password.</p>
            {errorMessage != null && <p className='invalid-feedback d-block text-center'>{errorMessage}</p>}
            {successMessage != null && <p className='valid-feedback d-block text-center'>{successMessage}</p>}
            <div className="mb-2">
              <label className="form-label">Email address</label>
              <input onChange={(e)=>{blankError(e.target.value, e.target.name)}} type="text" name="email" className={emailBlank == true ? "form-control is-invalid" : "form-control"} placeholder="Enter your email address" required/>
              {emailBlank == true && <div className='invalid-feedback d-block'>Email is required</div>}
            </div>
            <div className="form-footer">
              <button type="submit" className="btn btn-primary w-100">
                <svg xmlns="http://www.w3.org/2000/svg" className="icon" width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><rect x="3" y="5" width="18" height="14" rx="2" /><polyline points="3 7 12 13 21 7" /></svg>
                  Reset Password
              </button>
              <div className="form-hint mt-1"><span className='strong'>Current IP: </span>{clientIP}</div>
            </div>
          </div>
        </form>
        <div className="text-center text-muted mt-3">
          Wait! I remember! Send me back to the <Link to="/login" tabIndex="-1"> Sign In </Link> page!
        </div>
      </div>
    </div>

    <script src="./dist/js/tabler.min.js"></script>
  </div>
    )
}

export default PasswordReset